<div id="recruiter" class="my-4" data-scroll>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center">Industry Partners</h2>
            </div>
        </div>
        <div class="row">
            <marquee behavior="scroll" direction="left" scrollamount="10" loop="infinite">
                <ul class="d-flex justify-content-center align-items-center">
                    <li *ngFor="let item of logos">
                        <img [src]="item" alt="Logo" class="img-fluid">
                    </li>
                </ul>
            </marquee>
        </div>
    </div>
</div>